;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { getQueryClient as getBaseQueryClient } from '@workspace/ui/providers';

export const WALLET_QUERY_STALE_TIME = 5 * 60 * 1000;

export function getQueryClient() {
  return getBaseQueryClient({ staleTime: WALLET_QUERY_STALE_TIME });
}
